<template>
  <draggable
    :group="{ name: 'module', put: false, pull: 'clone' }"
    :sort="false"
    :value="childModules"
    class="link-drag"
  >
    <div v-for="item in childModules" :key="item.navId" class="link-item-box">
      <div class="link-item">
        {{item.navName}}
        <div class="selected" v-if="ifSelected(item)">已选</div>
      </div>
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "tinfoLinkC",
  components: { draggable },
  props: ['childModules','homeModules'],
  data() {
    return {};
  },
  created() {
  },
  computed: {},
  methods: {
    addClick(data){
      this.$emit('addClick', data)
    },
    ifSelected(val){
      let linkModule = this.homeModules.find(item => item.cardType === 'LINK')
      if(linkModule){
        if(linkModule.cardModules[0].data){
          return linkModule.cardModules[0].data.some(item => item.navId === val.navId)
        }
        return false
      }
      return false
    }
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less" >
.link-drag {
  display: flex;
  flex-wrap: wrap;
}
.link-item-box {
  width: 50%;
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  .link-item {
    width: 135px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #eef4f9;
    border-radius: 4px;
    position: relative;
    cursor: move;
    overflow: hidden;
  }
}
</style>